<div class="strip" (click)="onStripClick()">
  <div class="strip-content" *ngIf="!isExpanded">
    <div>תמונות שנותרו להעלאה: {{ firebaseService.imagesToUploadLeft }}</div>
    <div>Version: {{ version }}</div>
  </div>
  <div class="expanded-content" *ngIf="isExpanded">
    <div>תמונות שנותרו להעלאה: {{ firebaseService.imagesToUploadLeft }}</div>
    <div>Version: {{ version }}</div>
  </div>
</div>